import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'app-input-text-group',
	templateUrl: './input-text-group.component.html'
})
export class InputTextGroupComponent implements OnInit {//, OnChanges

	@Input() className:string = "";
	@Input() inputText: string[] = [];
	@Input() inputArrayName: string = null;
	@Input() inputFormGroup: FormGroup = new FormGroup({});
	@Input() consoleLogs: boolean = false;
	@Input() attemptedSubmit: boolean = false;

	@Output() removeAt: EventEmitter<number> = new EventEmitter<number>();

	constructor() { }

	ngOnInit(): void {
		if(this.consoleLogs) console.log('InputTextGroupComponent.ngOninit.inputArrayName: ', this.inputArrayName);
		if(this.consoleLogs) console.log('InputTextGroupComponent.ngOninit.inputFormGroup: ', this.inputFormGroup);
		if(this.consoleLogs) console.log('InputTextGroupComponent.attemptedSubmit: ', this.attemptedSubmit);
	}


	/**
	 * Remove TextInput from component, update array
	 * @param index 
	 * @param id 
	 */
	 public removeTextInput(index: any) {
		if(this.consoleLogs) console.log('InputTextGroupComponent.removeTextInput: ', index);
		this.removeAt.emit(index);
	}


}


